export default "__VITE_ASSET__DXzVfB5g__"